import { DateFilterType, RelativeDate } from '../machines/billingFilters/types';
import { manipulateDate, formatDate } from '@chargify/formatters';

export const getAbsoluteDate = (date: RelativeDate) => ({
  startDate: formatDate(
    manipulateDate({
      date: new Date(),
      method: 'subtract',
      unit: date.unit,
      value: date.value,
    })
  ),
  endDate: formatDate(new Date()),
});

export const getDatesFilter = (date: DateFilterType) => {
  if (date.type === 'timeRange' && (date.startDate || date.endDate)) {
    const { dateField, startDate, endDate } = date;
    return {
      startDate: startDate ? formatDate(startDate) : null,
      endDate: endDate ? formatDate(endDate) : null,
      dateField: dateField,
    };
  } else if (date.type === 'relative' && date.value) {
    return {
      ...getAbsoluteDate(date),
      dateField: date.dateField,
    };
  }
};
